import { computed, ref } from 'vue'

// Module-level so the App-shell outlet and HeaderAI share the split-pane state.
const open = ref(false)

// Mounted HeaderAI panels; views without the chat (e.g. the hub) mount none.
const mountedPanels = ref(0)

// `open` survives visits to chat-less views, so the pane reappears when the
// user returns to a chart view.
const visible = computed(() => open.value && mountedPanels.value > 0)

/**
 * Shared state for the AI chat split pane.
 * @returns {{open: import('vue').Ref<boolean>, visible: import('vue').ComputedRef<boolean>, mountedPanels: import('vue').Ref<number>}} the shared panel state
 */
export const useAiPanel = () => ({ open, visible, mountedPanels })
